import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

let registered = false

/** Matches the easing curve used across the source design. */
const registerEases = (): void => {
    gsap.registerEase('nuvea', (progress: number) => 1 - Math.pow(1 - progress, 3.2))
}

/**
 * Registers the GSAP plugins once, on the client only.
 * Safe to call from any effect; it is a no-op on repeat calls.
 */
export const registerMotion = (): typeof gsap => {
    if (typeof window !== 'undefined' && !registered) {
        registered = true

        registerEases()
        gsap.registerPlugin(ScrollTrigger)
        gsap.defaults({ ease: 'nuvea', duration: 1 })

        ScrollTrigger.config({ ignoreMobileResize: true })
    }

    return gsap
}

export const EASE = {
    out: 'nuvea',
    soft: 'power2.out',
    inOut: 'power3.inOut'
} as const

export const prefersReducedMotion = (): boolean => {
    if (typeof window === 'undefined') return false
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches
}

export { gsap, ScrollTrigger }
